export type ThemeMode = "dark" | "light";

const themeStorageKey = "orni-theme";

export function readTheme(): ThemeMode {
  try {
    return window.localStorage.getItem(themeStorageKey) === "light"
      ? "light"
      : "dark";
  } catch {
    return "dark";
  }
}

export function applyTheme(theme: ThemeMode): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  try {
    window.localStorage.setItem(themeStorageKey, theme);
  } catch {
    // The selected theme still applies for this page when storage is unavailable.
  }
}
